module.exports = __webpack_public_path__ + "img/20190709164714466.29f2cf08.png";